import axios from '../api/index.js';

//查询通知公告列表
export let getNoticeQuery = (params) => {
    return axios.post(`/client/notice/list`,params);
};

//查询通知公告介绍详情
export let getNoticeContent = (params) => {
    return axios.get(`/client/notice/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/notice.js